import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useIconLib } from '#imports'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionSubmenu',
  props: {
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: undefined
  },
  icon: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: undefined
  }
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_list, {
    variant: "flat",
    rounded: "lg",
    "bg-color": __props.color
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list_group, null, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_list_item, _mergeProps(props, {
            "prepend-icon": _unref(useIconLib)(__props.icon),
            title: __props.title,
            subtitle: __props.subtitle,
            "base-color": __props.color,
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
          }), null, 16, ["prepend-icon", "title", "subtitle", "base-color"])
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["bg-color"]))
}
}

})